import { FC, forwardRef, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'rsuite';

interface NavLinkProps {
  href: string;
  children: ReactNode;
}

const NavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ href, children, ...rest }, ref) => (
    <Link ref={ref} to={href} {...rest}>
      {children}
    </Link>
  ),
);

type BreadCrumbData =
  | {
      label: ReactNode;
      href: string;
    }
  | {
      label: ReactNode;
      active: true;
    };

interface RsBreadCrumbProps {
  data: BreadCrumbData[];
}

export const RsBreadCrumb: FC<RsBreadCrumbProps> = ({ data = [] }) => {
  return (
    <Breadcrumb>
      {data.map((item, i) =>
        'active' in item ? (
          <Breadcrumb.Item key={i} as={NavLink} active>
            {item.label}
          </Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item key={i} as={NavLink} href={item.href}>
            {item.label}
          </Breadcrumb.Item>
        ),
      )}
    </Breadcrumb>
  );
};
